module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dimensions-field-widget"
  }, [_c('div', [_c('a', {
    staticClass: "doc-link doc-link-pdf",
    attrs: {
      "href": _vm.docLink,
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.dimension.docLink)
    }
  })]), _c('div', {
    staticClass: "double-dimension-field-container"
  }, [_c('div', {
    staticClass: "double-dimension-field-item"
  }, [_c('Dimension', {
    attrs: {
      "field": _vm.hookedWidthField,
      "mint": _vm.mint,
      "fieldRef": _vm.hookedWidthField.chKey,
      "cc_value": _vm.getCcWidthValue,
      "uom": _vm.uom
    },
    on: {
      "field-changed": _vm.fieldHasChanged
    }
  })], 1), _c('div', {
    staticClass: "double-dimension-field-item"
  }, [_c('Dimension', {
    attrs: {
      "field": _vm.hookedHeightField,
      "mint": _vm.mint,
      "fieldRef": _vm.hookedHeightField.chKey,
      "cc_value": _vm.getCcHeightValue,
      "uom": _vm.uom
    },
    on: {
      "field-changed": _vm.fieldHasChanged
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62664e88!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/DimensionsFieldWidget.vue
// module id = 358
// module chunks = 1